/* eslint-disable camelcase */
import { useState } from 'react'
import { InfoButton } from 'components/buttons'
import { refreshCache } from 'lib/cache-utils'
import { errorMessage, successMessage } from 'lib/flash-message'
import FeedAdminToolsVersion1 from './FeedAdminToolsVersion1/FeedAdminToolsVersion1'
import FeedAdminToolsVersion2 from './FeedAdminToolsVersion2/FeedAdminToolsVersion2'
// @ts-ignore-line
import css from './FeedAdminTools.scss'

export interface FeedAdminOverride {
  // Feed Version 1 overrides:
  session?: string

  // Feed Version 2 overrides (must be stringified JSON):
  feed_overrides?: string
}

interface FeedAdminToolsProps {
  isFetchingFeed: boolean
  onSubmit: (overrides: FeedAdminOverride) => void
}

const FeedAdminTool = (props: FeedAdminToolsProps) => {
  const { isFetchingFeed, onSubmit } = props

  const [submittingClearCache, setSubmittingClearCache] = useState(false)
  const [feedVersionOverride, setFeedVersionOverride] = useState(1)

  const handleClearCache = () => {
    setSubmittingClearCache(true)
    refreshCache([
      { name: 'BLContent::FeedItem' },
      { name: 'BLContent::FeedPriorityItem' },
    ])
      .then(() => {
        successMessage(
          'Success! Feed content will be refreshed from Contentful in a few minutes.'
        )
      })
      .catch(() => {
        errorMessage('Uh oh...there was an error try to clear the cache!')
      })
      .finally(() => {
        setSubmittingClearCache(false)
      })
  }

  const FeedAdminToolsVersionComponent =
    feedVersionOverride === 1 ? FeedAdminToolsVersion1 : FeedAdminToolsVersion2

  return (
    <>
      <div className="h6 mtxl">Feed Admin Tools</div>
      <div>
        {[
          { name: 'Content Preview', value: 1 },
          { name: 'Visit Preview', value: 2 },
        ].map((radio, idx) => (
          <label
            className={css.RadioOption}
            htmlFor={`feed-version-radio-${idx}`}
            // eslint-disable-next-line react/no-array-index-key
            key={`feed-version-radio-${idx}`}
          >
            <input
              id={`feed-version-radio-${idx}`}
              type="radio"
              name={`feed-version-radio-${idx}`}
              value={radio.value}
              checked={feedVersionOverride === radio.value}
              onChange={() => setFeedVersionOverride(radio.value)}
            />{' '}
            {radio.name}
          </label>
        ))}
      </div>
      <br />
      <FeedAdminToolsVersionComponent
        isFetchingFeed={isFetchingFeed}
        onSubmit={onSubmit}
      />
      <br />
      <InfoButton
        block
        empty
        pill
        className="mbm"
        size="large"
        onClick={handleClearCache}
        submitting={submittingClearCache}
      >
        Clear Cache
      </InfoButton>
    </>
  )
}

export default FeedAdminTool
